import { useEffect, useRef, useState } from 'react'

export const useHiddenFeature = (callback: () => void, clickLimit: number, action = 'click') => {
  const [clickCount, setClickCount] = useState(0)
  const [isActivated, setIsActivated] = useState(false)
  const targetRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!isActivated && clickCount >= clickLimit) {
      callback()
      setIsActivated(true)
      alert('Hidden feature activated!')
      setClickCount(0)
    }
  }, [callback, clickCount, clickLimit, isActivated])

  useEffect(() => {
    if (targetRef.current) {
      const handleClick = () => setClickCount((prev) => prev + 1)
      targetRef.current.addEventListener(action, handleClick)

      return () => {
        targetRef.current?.removeEventListener(action, handleClick)
      }
    }
  }, [action])

  return targetRef
}
